import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

export enum FORMAT_DATE {
    AR = 'DD/MM/YYYY',
    AR_HOUR_MIN = 'DD/MM/YYYY HH:mm',
  }

const DEFAULT_PARSE_FORMATS = [
  FORMAT_DATE.AR,
  'YYYY-MM-DD',
  'DD-MM-YYYY',
  'YYYYMMDD',
]

 dayjs.extend(customParseFormat);

export const formatDate = (date: string, format?: string | undefined) => {
    if( date?.length ) {
        const parsed = format ? dayjs(date,format) : dayjs(date, DEFAULT_PARSE_FORMATS);
        if(!parsed.isValid){
          return '-';
        }
        return parsed.format(FORMAT_DATE.AR).toString();
    }

    return '-';
};

export function safeFormatHour(hora: any): string {
  if (!hora) return '';
  return dayjs(hora, ['H:mm', 'HH:mm']).format('HH:mm');
}